// Alert API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type AlertNotificationsRequests = {
    hasUnreadAlerts: RequestConfigFunction,
    getAll: RequestConfigFunction<Record<string, any>>,
    markAsRead: RequestConfigFunction<{id: number}>,
    markAsUnread: RequestConfigFunction<{id: number}>,
}

const alertNotificationRequests: AlertNotificationsRequests = {
    getAll: (data) => {
        return {
            url: 'useralert/filter-request/all',
            method: 'POST',
            ...data,
        }
    },
    markAsRead: ({
        id,
    }) => {
        return {
            url: `useralert/${id}/read`,
            method: 'PATCH',
        }
    },
    markAsUnread: ({
        id,
    }) => {
        return {
            url: `useralert/${id}/unread`,
            method: 'PATCH',
        }
    },
    hasUnreadAlerts: () => {
        return {
            url: 'useralert/unread',
            method: 'GET',
        }
    },
}

export default alertNotificationRequests
